module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@2x-15028552da7506203713149d0e6995fb.webp";